import React, { useCallback } from "react";
import { Select as AntdSelect } from "antd";
import ee from "../../../services/EventEmitter";
import { IObjectMap } from "../../../interfaces/common";
import { Option } from "../../common/forms/Interfaces";
import { generate, generateByKey } from "../../../helpers/hash";

interface Props {
  string: keyof IObjectMap;
  entityKey: string;
  entityId: unknown;
  options: Option[];
  showSearch?: boolean;
  eventKey?: string;
  className?: string;
  disabled?: boolean;
  multiple?: boolean;
}

const UNIQUE_ID = generate();

const getOptions = (options: Option[]) => {
  return options.map((option, key) => (
    <AntdSelect.Option
      key={generateByKey(key.toString(), UNIQUE_ID)}
      value={option.value}
    >
      {option.title}
    </AntdSelect.Option>
  ));
};

const Select: React.FC<Props> = ({
  string,
  entityKey,
  entityId,
  options,
  showSearch,
  eventKey,
  className,
  disabled,
}) => {
  const onChangeHandler = useCallback(
    (optionValue: string) => {
      if (eventKey)
        ee.emit(eventKey, {
          entityId,
          entityKey,
          value: optionValue,
        });
    },
    [entityId, entityKey, eventKey]
  );

  return (
    <AntdSelect
      onChange={onChangeHandler}
      value={string as string}
      className={className ? `table-select ${className}` : "table-select"}
      size="small"
      showSearch={showSearch}
      filterOption={(input, option) => {
        if (!option) {
          return false;
        }

        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      disabled={disabled}
    >
      {getOptions(options)}
    </AntdSelect>
  );
};
export default Select;
